import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayer} from "@/helpers/ol/ol-layer-helper";
import {removeLayerActive} from "@/helpers/ol/ol-layer-active-helper";
import {clearInfoCharacteristics} from "@/helpers/layer/info/layer-info-characteristics-helper";
import {removeTemporaryLayer} from "@/helpers/layer/temporary/temporary-layer-helper";

const template = document.createElement('template');
template.innerHTML = `
<button title="Verwijder uit active lagen" class="btn btn-sm text-danger borderless icon-btn d-none">
    <span class="fa fa-times"></span>
</button>
`;

export class LayerMenuActiveItemRemoveComponent extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template)

        const id = this.getAttribute('data-id')

        this.addEventListener('click', () => {

            if(id.includes(',')) {
                id.split(',').map((id) => {
                    addLayer(id, false)
                    this.closest('layer-menu-group-merged').remove()

                    removeLayerActive(id)

                    const inputs = document.querySelectorAll('input[value="' + id + '"]');

                    inputs.forEach((input) => {
                        if(input) {
                            input.checked = false
                        }
                    })

                })

                const input = document.querySelector('input[value="' + this.getAttribute('data-parent-id') + '"]');
                if(input) {
                    input.checked = false
                }
            } else {
                const layerMenuGroupItem = this.closest('layer-menu-group-item')
                if(layerMenuGroupItem && layerMenuGroupItem.querySelector('input').checked) {
                    addLayer(id, false)
                }

                removeLayerActive(id)
                removeTemporaryLayer(id)

                const input = document.querySelector('input[value="' + id + '"]');
                if(input) {
                    input.checked = false
                }
            }

            clearInfoCharacteristics()
        })
    }
}
